import { axiosClient } from "../axios";

const baseUrl = "/api/registry/firms";

export function getAll() {
  return axiosClient.get(baseUrl);
}

export function get(id) {
  return axiosClient.get(`${baseUrl}/${id}`);
}

export function create(data) {
  return axiosClient.post(baseUrl, data);
}

export function update(firmId, data) {
  return axiosClient.post(`${baseUrl}/${firmId}`, data);
}

export function getSubscription(firmId) {
  return axiosClient.get(`${baseUrl}/${firmId}/subscription`);
}

export function updateSubscription(firmId, data) {
  return axiosClient.post(`${baseUrl}/${firmId}/subscription`, data);
}

export function toggle(firmId) {
  return axiosClient.post(`${baseUrl}/${firmId}/toggle`);
}

export function getEnterprises(firmId) {
  return axiosClient.get(`${baseUrl}/${firmId}/enterprises`);
}

export function recalculateUsageQuota(firmId) {
  return axiosClient.post(`${baseUrl}/${firmId}/usage-quota/recalculate`);
}
